import * as React from 'react';
import { FC, useState } from 'react';
import { useRefresh, useEditContext, useListContext, useDeleteMany, useNotify, useUnselectAll, Confirm } from 'react-admin';
import Button from '@mui/material/Button';
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';

interface Props {
    resource_guid: string;
    disabled?: boolean;
}

const CustomDBDiscontinueLicenseButton: FC<Props> = ({disabled = false, ...props}) => {

    const [open, setOpen] = useState(false);
    const refresh = useRefresh();
    const parent = useEditContext();
    const list = useListContext();
    const notify = useNotify();
    
    //const url = `${parent.resource}/${parent.record.guid}/${list.resource}/permanent`;
    //const url = `${list.resource}/permanentdelete`;
    //kovakoodattu, koska ei käytetä muussa tapauksessa #kim 14.3.2025
    const url = `userlicense/discontinue`;
    
    //console.log(url);
    //console.log(props.resource_guid);

    //const unselectAll = useUnselectAll(list.resource);

    const [deleteMany, { isLoading }] = useDeleteMany(
        url,
        { ids: [props.resource_guid] },
        {
            onSuccess: () => {
                refresh();
                //unselectAll();
            },
            onError: error => notify(`Virhe keskeytyksessä: ${error}`, { type: 'warning' }),
        }
    );

    const handleClick = (e) =>  {
        e.stopPropagation();
        setOpen(true);
    }
    const handleDialogClose = () => {
        refresh();
        //unselectAll();
        setOpen(false);
    }

    const handleConfirm = () => {
        deleteMany();
        setOpen(false);
    };

    return (
        <>
            <Button onClick={disabled ? undefined : handleClick} disabled={isLoading || disabled} color='success'>{!disabled && <DesktopWindowsOutlinedIcon />}{disabled && <DesktopAccessDisabledIcon />}</Button>
            <Confirm
                isOpen={open}
                loading={isLoading}
                title="Keskeytä valittu lisenssi"
                content={"Haluatko varmasti keskeyttää valitsemasi lisenssin pysyvästi?"}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </>
    );
};

export default CustomDBDiscontinueLicenseButton;
